import { Route } from 'react-router-dom';
import * as urls from '../routePaths';
import Projects from '../pages/Projects';
import Project from '../pages/Project';
import ProjectVideo from '../pages/ProjectVideo';
import ProjectVideoTranscript from '../pages/ProjectVideoTranscript';
import RoleSwitchedProject from './RoleSwitchedProject';

const ProjectsRoutes = [
  <Route path={urls.PROJECTS_URL} element={<Projects />} key="projects" />,
  <Route
    path={urls.PROJECT_URL}
    element={
      <RoleSwitchedProject>
        <Project />
      </RoleSwitchedProject>
    }
    key="project"
  />,
  <Route
    path={urls.PROJECT_VIDEO_URL}
    element={
      <RoleSwitchedProject>
        <ProjectVideo />
      </RoleSwitchedProject>
    }
    key="project-video"
  />,
  // <Route
  //   path={urls.PROJECT_TRANSCRIPT_URL}
  //   element={<ProjectVideoTranscript />}
  //   key="project-transcript"
  // />,
  <Route
    path={urls.PROJECT_TRANSCRIPT_URL}
    element={<ProjectVideoTranscript />}
    key="project-transcript"
  />,
  <Route
    path={urls.PROJECT_VIDEO_TRANSCRIPT_URL}
    element={<ProjectVideoTranscript />}
    key="project-video-transcript"
  />,
];

export default ProjectsRoutes;
